var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bizAuth.createRole.hasRight)?_c('div',{staticClass:"biz-add-employee-role-page"},[_c('add-employee-role-comp',{class:{'fixed': _vm.listIsFixed}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-223dc9fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bussiness/internalAuth/employeeRole/addEmployeeRole.vue
// module id = null
// module chunks = 